"use client";

import { Progress as ProgressPrimitive } from "@base-ui/react/progress";
// shadcn progress https://ui.shadcn.com/docs/components/progress
import * as React from "react";

import { cn } from "@/lib/utils";

type ProgressRootProps = React.ComponentPropsWithoutRef<
  typeof ProgressPrimitive.Root
>;

type ProgressProps = Omit<ProgressRootProps, "value"> & {
  value?: number | null;
};

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  ProgressProps
>(({ className, value = 0, ...props }, ref) => (
  <ProgressPrimitive.Root
    ref={ref}
    value={value}
    className={cn("relative h-4 w-full rounded-full", className)}
    {...props}
  >
    <ProgressPrimitive.Track className="bg-secondary size-full overflow-hidden rounded-[inherit]">
      <ProgressPrimitive.Indicator className="bg-primary h-full transition-all motion-reduce:transition-none" />
    </ProgressPrimitive.Track>
  </ProgressPrimitive.Root>
));
Progress.displayName = "Progress";

export { Progress };
